(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Ahana-philosophy"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__ahanaRise) return; window.__ahanaRise = true;

  function reveals() {
    document.querySelectorAll('.ahana-rise').forEach(function (s) { s.classList.add('reveal-ready'); });
    var els = [].slice.call(document.querySelectorAll('.ahana-rise [data-reveal]:not([data-arseen])'));
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('in'); e.setAttribute('data-arseen','1'); });
      return;
    }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' });
    els.forEach(function (e) { e.setAttribute('data-arseen','1'); io.observe(e); });
  }

  function motes(canvas) {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var ctx = canvas.getContext('2d');
    function resize(){ canvas.width = canvas.offsetWidth; canvas.height = canvas.offsetHeight; }
    resize();
    if ('ResizeObserver' in window) new ResizeObserver(resize).observe(canvas);
    else window.addEventListener('resize', resize, { passive:true });
    var C = ['rgba(201,150,90,','rgba(216,188,150,','rgba(160,72,48,','rgba(196,160,96,'];
    function M(){ this.reset(true); }
    M.prototype.reset = function(init){
      this.x=Math.random()*canvas.width; this.y=init?Math.random()*canvas.height:canvas.height+12;
      this.r=Math.random()*1.6+0.3; this.vy=-(Math.random()*0.35+0.08); this.vx=(Math.random()-0.5)*0.12;
      this.alpha=0; this.maxA=Math.random()*0.45+0.08; this.fade=Math.random()*0.006+0.002;
      this.phase=Math.random()*Math.PI*2; this.wobble=Math.random()*0.004+0.001;
      this.color=C[Math.floor(Math.random()*C.length)]; this.life=0; this.maxLife=Math.random()*400+200;
    };
    M.prototype.update=function(){
      this.life++; this.phase+=this.wobble; this.x+=this.vx+Math.sin(this.phase)*0.18; this.y+=this.vy;
      if(this.life<60) this.alpha=Math.min(this.maxA,this.alpha+this.fade*2.5);
      else if(this.life>this.maxLife-80) this.alpha=Math.max(0,this.alpha-this.fade*1.5);
      if(this.life>=this.maxLife||this.y<-10) this.reset(false);
    };
    M.prototype.draw=function(){ ctx.beginPath(); ctx.arc(this.x,this.y,this.r,0,Math.PI*2); ctx.fillStyle=this.color+this.alpha+')'; ctx.fill(); };
    var arr=[]; for(var i=0;i<90;i++) arr.push(new M());
    var vis=true;
    if('IntersectionObserver' in window) new IntersectionObserver(function(e){vis=e[0].isIntersecting;},{threshold:0}).observe(canvas);
    (function loop(){ if(vis){ ctx.clearRect(0,0,canvas.width,canvas.height); for(var k=0;k<arr.length;k++){arr[k].update();arr[k].draw();} } requestAnimationFrame(loop); })();
  }

  function canvases(){
    document.querySelectorAll('.ahana-rise-canvas:not([data-arseen])').forEach(function(cv){ cv.setAttribute('data-arseen','1'); motes(cv); });
  }

  function init(){ reveals(); canvases(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ahana-band"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__ahanaRise) return; window.__ahanaRise = true;

  function reveals() {
    document.querySelectorAll('.ahana-rise').forEach(function (s) { s.classList.add('reveal-ready'); });
    var els = [].slice.call(document.querySelectorAll('.ahana-rise [data-reveal]:not([data-arseen])'));
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('in'); e.setAttribute('data-arseen','1'); });
      return;
    }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' });
    els.forEach(function (e) { e.setAttribute('data-arseen','1'); io.observe(e); });
  }

  function motes(canvas) {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var ctx = canvas.getContext('2d');
    function resize(){ canvas.width = canvas.offsetWidth; canvas.height = canvas.offsetHeight; }
    resize();
    if ('ResizeObserver' in window) new ResizeObserver(resize).observe(canvas);
    else window.addEventListener('resize', resize, { passive:true });
    var C = ['rgba(201,150,90,','rgba(216,188,150,','rgba(160,72,48,','rgba(196,160,96,'];
    function M(){ this.reset(true); }
    M.prototype.reset = function(init){
      this.x=Math.random()*canvas.width; this.y=init?Math.random()*canvas.height:canvas.height+12;
      this.r=Math.random()*1.6+0.3; this.vy=-(Math.random()*0.35+0.08); this.vx=(Math.random()-0.5)*0.12;
      this.alpha=0; this.maxA=Math.random()*0.45+0.08; this.fade=Math.random()*0.006+0.002;
      this.phase=Math.random()*Math.PI*2; this.wobble=Math.random()*0.004+0.001;
      this.color=C[Math.floor(Math.random()*C.length)]; this.life=0; this.maxLife=Math.random()*400+200;
    };
    M.prototype.update=function(){
      this.life++; this.phase+=this.wobble; this.x+=this.vx+Math.sin(this.phase)*0.18; this.y+=this.vy;
      if(this.life<60) this.alpha=Math.min(this.maxA,this.alpha+this.fade*2.5);
      else if(this.life>this.maxLife-80) this.alpha=Math.max(0,this.alpha-this.fade*1.5);
      if(this.life>=this.maxLife||this.y<-10) this.reset(false);
    };
    M.prototype.draw=function(){ ctx.beginPath(); ctx.arc(this.x,this.y,this.r,0,Math.PI*2); ctx.fillStyle=this.color+this.alpha+')'; ctx.fill(); };
    var arr=[]; for(var i=0;i<90;i++) arr.push(new M());
    var vis=true;
    if('IntersectionObserver' in window) new IntersectionObserver(function(e){vis=e[0].isIntersecting;},{threshold:0}).observe(canvas);
    (function loop(){ if(vis){ ctx.clearRect(0,0,canvas.width,canvas.height); for(var k=0;k<arr.length;k++){arr[k].update();arr[k].draw();} } requestAnimationFrame(loop); })();
  }

  function canvases(){
    document.querySelectorAll('.ahana-rise-canvas:not([data-arseen])').forEach(function(cv){ cv.setAttribute('data-arseen','1'); motes(cv); });
  }

  function init(){ reveals(); canvases(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ahana-benefits"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__ahanaRise) return; window.__ahanaRise = true;

  function reveals() {
    document.querySelectorAll('.ahana-rise').forEach(function (s) { s.classList.add('reveal-ready'); });
    var els = [].slice.call(document.querySelectorAll('.ahana-rise [data-reveal]:not([data-arseen])'));
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('in'); e.setAttribute('data-arseen','1'); });
      return;
    }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' });
    els.forEach(function (e) { e.setAttribute('data-arseen','1'); io.observe(e); });
  }

  function motes(canvas) {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var ctx = canvas.getContext('2d');
    function resize(){ canvas.width = canvas.offsetWidth; canvas.height = canvas.offsetHeight; }
    resize();
    if ('ResizeObserver' in window) new ResizeObserver(resize).observe(canvas);
    else window.addEventListener('resize', resize, { passive:true });
    var C = ['rgba(201,150,90,','rgba(216,188,150,','rgba(160,72,48,','rgba(196,160,96,'];
    function M(){ this.reset(true); }
    M.prototype.reset = function(init){
      this.x=Math.random()*canvas.width; this.y=init?Math.random()*canvas.height:canvas.height+12;
      this.r=Math.random()*1.6+0.3; this.vy=-(Math.random()*0.35+0.08); this.vx=(Math.random()-0.5)*0.12;
      this.alpha=0; this.maxA=Math.random()*0.45+0.08; this.fade=Math.random()*0.006+0.002;
      this.phase=Math.random()*Math.PI*2; this.wobble=Math.random()*0.004+0.001;
      this.color=C[Math.floor(Math.random()*C.length)]; this.life=0; this.maxLife=Math.random()*400+200;
    };
    M.prototype.update=function(){
      this.life++; this.phase+=this.wobble; this.x+=this.vx+Math.sin(this.phase)*0.18; this.y+=this.vy;
      if(this.life<60) this.alpha=Math.min(this.maxA,this.alpha+this.fade*2.5);
      else if(this.life>this.maxLife-80) this.alpha=Math.max(0,this.alpha-this.fade*1.5);
      if(this.life>=this.maxLife||this.y<-10) this.reset(false);
    };
    M.prototype.draw=function(){ ctx.beginPath(); ctx.arc(this.x,this.y,this.r,0,Math.PI*2); ctx.fillStyle=this.color+this.alpha+')'; ctx.fill(); };
    var arr=[]; for(var i=0;i<90;i++) arr.push(new M());
    var vis=true;
    if('IntersectionObserver' in window) new IntersectionObserver(function(e){vis=e[0].isIntersecting;},{threshold:0}).observe(canvas);
    (function loop(){ if(vis){ ctx.clearRect(0,0,canvas.width,canvas.height); for(var k=0;k<arr.length;k++){arr[k].update();arr[k].draw();} } requestAnimationFrame(loop); })();
  }

  function canvases(){
    document.querySelectorAll('.ahana-rise-canvas:not([data-arseen])').forEach(function(cv){ cv.setAttribute('data-arseen','1'); motes(cv); });
  }

  function init(){ reveals(); canvases(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ahana-cta"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__ahanaRise) return; window.__ahanaRise = true;

  function reveals() {
    document.querySelectorAll('.ahana-rise').forEach(function (s) { s.classList.add('reveal-ready'); });
    var els = [].slice.call(document.querySelectorAll('.ahana-rise [data-reveal]:not([data-arseen])'));
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('in'); e.setAttribute('data-arseen','1'); });
      return;
    }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' });
    els.forEach(function (e) { e.setAttribute('data-arseen','1'); io.observe(e); });
  }

  function motes(canvas) {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var ctx = canvas.getContext('2d');
    function resize(){ canvas.width = canvas.offsetWidth; canvas.height = canvas.offsetHeight; }
    resize();
    if ('ResizeObserver' in window) new ResizeObserver(resize).observe(canvas);
    else window.addEventListener('resize', resize, { passive:true });
    var C = ['rgba(201,150,90,','rgba(216,188,150,','rgba(160,72,48,','rgba(196,160,96,'];
    function M(){ this.reset(true); }
    M.prototype.reset = function(init){
      this.x=Math.random()*canvas.width; this.y=init?Math.random()*canvas.height:canvas.height+12;
      this.r=Math.random()*1.6+0.3; this.vy=-(Math.random()*0.35+0.08); this.vx=(Math.random()-0.5)*0.12;
      this.alpha=0; this.maxA=Math.random()*0.45+0.08; this.fade=Math.random()*0.006+0.002;
      this.phase=Math.random()*Math.PI*2; this.wobble=Math.random()*0.004+0.001;
      this.color=C[Math.floor(Math.random()*C.length)]; this.life=0; this.maxLife=Math.random()*400+200;
    };
    M.prototype.update=function(){
      this.life++; this.phase+=this.wobble; this.x+=this.vx+Math.sin(this.phase)*0.18; this.y+=this.vy;
      if(this.life<60) this.alpha=Math.min(this.maxA,this.alpha+this.fade*2.5);
      else if(this.life>this.maxLife-80) this.alpha=Math.max(0,this.alpha-this.fade*1.5);
      if(this.life>=this.maxLife||this.y<-10) this.reset(false);
    };
    M.prototype.draw=function(){ ctx.beginPath(); ctx.arc(this.x,this.y,this.r,0,Math.PI*2); ctx.fillStyle=this.color+this.alpha+')'; ctx.fill(); };
    var arr=[]; for(var i=0;i<90;i++) arr.push(new M());
    var vis=true;
    if('IntersectionObserver' in window) new IntersectionObserver(function(e){vis=e[0].isIntersecting;},{threshold:0}).observe(canvas);
    (function loop(){ if(vis){ ctx.clearRect(0,0,canvas.width,canvas.height); for(var k=0;k<arr.length;k++){arr[k].update();arr[k].draw();} } requestAnimationFrame(loop); })();
  }

  function canvases(){
    document.querySelectorAll('.ahana-rise-canvas:not([data-arseen])').forEach(function(cv){ cv.setAttribute('data-arseen','1'); motes(cv); });
  }

  function init(){ reveals(); canvases(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ahana-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__ahanaRise) return; window.__ahanaRise = true;

  function reveals() {
    document.querySelectorAll('.ahana-rise').forEach(function (s) { s.classList.add('reveal-ready'); });
    var els = [].slice.call(document.querySelectorAll('.ahana-rise [data-reveal]:not([data-arseen])'));
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('in'); e.setAttribute('data-arseen','1'); });
      return;
    }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' });
    els.forEach(function (e) { e.setAttribute('data-arseen','1'); io.observe(e); });
  }

  function motes(canvas) {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var ctx = canvas.getContext('2d');
    function resize(){ canvas.width = canvas.offsetWidth; canvas.height = canvas.offsetHeight; }
    resize();
    if ('ResizeObserver' in window) new ResizeObserver(resize).observe(canvas);
    else window.addEventListener('resize', resize, { passive:true });
    var C = ['rgba(201,150,90,','rgba(216,188,150,','rgba(160,72,48,','rgba(196,160,96,'];
    function M(){ this.reset(true); }
    M.prototype.reset = function(init){
      this.x=Math.random()*canvas.width; this.y=init?Math.random()*canvas.height:canvas.height+12;
      this.r=Math.random()*1.6+0.3; this.vy=-(Math.random()*0.35+0.08); this.vx=(Math.random()-0.5)*0.12;
      this.alpha=0; this.maxA=Math.random()*0.45+0.08; this.fade=Math.random()*0.006+0.002;
      this.phase=Math.random()*Math.PI*2; this.wobble=Math.random()*0.004+0.001;
      this.color=C[Math.floor(Math.random()*C.length)]; this.life=0; this.maxLife=Math.random()*400+200;
    };
    M.prototype.update=function(){
      this.life++; this.phase+=this.wobble; this.x+=this.vx+Math.sin(this.phase)*0.18; this.y+=this.vy;
      if(this.life<60) this.alpha=Math.min(this.maxA,this.alpha+this.fade*2.5);
      else if(this.life>this.maxLife-80) this.alpha=Math.max(0,this.alpha-this.fade*1.5);
      if(this.life>=this.maxLife||this.y<-10) this.reset(false);
    };
    M.prototype.draw=function(){ ctx.beginPath(); ctx.arc(this.x,this.y,this.r,0,Math.PI*2); ctx.fillStyle=this.color+this.alpha+')'; ctx.fill(); };
    var arr=[]; for(var i=0;i<90;i++) arr.push(new M());
    var vis=true;
    if('IntersectionObserver' in window) new IntersectionObserver(function(e){vis=e[0].isIntersecting;},{threshold:0}).observe(canvas);
    (function loop(){ if(vis){ ctx.clearRect(0,0,canvas.width,canvas.height); for(var k=0;k<arr.length;k++){arr[k].update();arr[k].draw();} } requestAnimationFrame(loop); })();
  }

  function canvases(){
    document.querySelectorAll('.ahana-rise-canvas:not([data-arseen])').forEach(function(cv){ cv.setAttribute('data-arseen','1'); motes(cv); });
  }

  function init(){ reveals(); canvases(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ahana-journey"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__ahanaRise) return; window.__ahanaRise = true;

  function reveals() {
    document.querySelectorAll('.ahana-rise').forEach(function (s) { s.classList.add('reveal-ready'); });
    var els = [].slice.call(document.querySelectorAll('.ahana-rise [data-reveal]:not([data-arseen])'));
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('in'); e.setAttribute('data-arseen','1'); });
      return;
    }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' });
    els.forEach(function (e) { e.setAttribute('data-arseen','1'); io.observe(e); });
  }

  function motes(canvas) {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var ctx = canvas.getContext('2d');
    function resize(){ canvas.width = canvas.offsetWidth; canvas.height = canvas.offsetHeight; }
    resize();
    if ('ResizeObserver' in window) new ResizeObserver(resize).observe(canvas);
    else window.addEventListener('resize', resize, { passive:true });
    var C = ['rgba(201,150,90,','rgba(216,188,150,','rgba(160,72,48,','rgba(196,160,96,'];
    function M(){ this.reset(true); }
    M.prototype.reset = function(init){
      this.x=Math.random()*canvas.width; this.y=init?Math.random()*canvas.height:canvas.height+12;
      this.r=Math.random()*1.6+0.3; this.vy=-(Math.random()*0.35+0.08); this.vx=(Math.random()-0.5)*0.12;
      this.alpha=0; this.maxA=Math.random()*0.45+0.08; this.fade=Math.random()*0.006+0.002;
      this.phase=Math.random()*Math.PI*2; this.wobble=Math.random()*0.004+0.001;
      this.color=C[Math.floor(Math.random()*C.length)]; this.life=0; this.maxLife=Math.random()*400+200;
    };
    M.prototype.update=function(){
      this.life++; this.phase+=this.wobble; this.x+=this.vx+Math.sin(this.phase)*0.18; this.y+=this.vy;
      if(this.life<60) this.alpha=Math.min(this.maxA,this.alpha+this.fade*2.5);
      else if(this.life>this.maxLife-80) this.alpha=Math.max(0,this.alpha-this.fade*1.5);
      if(this.life>=this.maxLife||this.y<-10) this.reset(false);
    };
    M.prototype.draw=function(){ ctx.beginPath(); ctx.arc(this.x,this.y,this.r,0,Math.PI*2); ctx.fillStyle=this.color+this.alpha+')'; ctx.fill(); };
    var arr=[]; for(var i=0;i<90;i++) arr.push(new M());
    var vis=true;
    if('IntersectionObserver' in window) new IntersectionObserver(function(e){vis=e[0].isIntersecting;},{threshold:0}).observe(canvas);
    (function loop(){ if(vis){ ctx.clearRect(0,0,canvas.width,canvas.height); for(var k=0;k<arr.length;k++){arr[k].update();arr[k].draw();} } requestAnimationFrame(loop); })();
  }

  function canvases(){
    document.querySelectorAll('.ahana-rise-canvas:not([data-arseen])').forEach(function(cv){ cv.setAttribute('data-arseen','1'); motes(cv); });
  }

  function init(){ reveals(); canvases(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ahana-manifesto"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__ahanaRise) return; window.__ahanaRise = true;

  function reveals() {
    document.querySelectorAll('.ahana-rise').forEach(function (s) { s.classList.add('reveal-ready'); });
    var els = [].slice.call(document.querySelectorAll('.ahana-rise [data-reveal]:not([data-arseen])'));
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('in'); e.setAttribute('data-arseen','1'); });
      return;
    }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' });
    els.forEach(function (e) { e.setAttribute('data-arseen','1'); io.observe(e); });
  }

  function motes(canvas) {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var ctx = canvas.getContext('2d');
    function resize(){ canvas.width = canvas.offsetWidth; canvas.height = canvas.offsetHeight; }
    resize();
    if ('ResizeObserver' in window) new ResizeObserver(resize).observe(canvas);
    else window.addEventListener('resize', resize, { passive:true });
    var C = ['rgba(201,150,90,','rgba(216,188,150,','rgba(160,72,48,','rgba(196,160,96,'];
    function M(){ this.reset(true); }
    M.prototype.reset = function(init){
      this.x=Math.random()*canvas.width; this.y=init?Math.random()*canvas.height:canvas.height+12;
      this.r=Math.random()*1.6+0.3; this.vy=-(Math.random()*0.35+0.08); this.vx=(Math.random()-0.5)*0.12;
      this.alpha=0; this.maxA=Math.random()*0.45+0.08; this.fade=Math.random()*0.006+0.002;
      this.phase=Math.random()*Math.PI*2; this.wobble=Math.random()*0.004+0.001;
      this.color=C[Math.floor(Math.random()*C.length)]; this.life=0; this.maxLife=Math.random()*400+200;
    };
    M.prototype.update=function(){
      this.life++; this.phase+=this.wobble; this.x+=this.vx+Math.sin(this.phase)*0.18; this.y+=this.vy;
      if(this.life<60) this.alpha=Math.min(this.maxA,this.alpha+this.fade*2.5);
      else if(this.life>this.maxLife-80) this.alpha=Math.max(0,this.alpha-this.fade*1.5);
      if(this.life>=this.maxLife||this.y<-10) this.reset(false);
    };
    M.prototype.draw=function(){ ctx.beginPath(); ctx.arc(this.x,this.y,this.r,0,Math.PI*2); ctx.fillStyle=this.color+this.alpha+')'; ctx.fill(); };
    var arr=[]; for(var i=0;i<90;i++) arr.push(new M());
    var vis=true;
    if('IntersectionObserver' in window) new IntersectionObserver(function(e){vis=e[0].isIntersecting;},{threshold:0}).observe(canvas);
    (function loop(){ if(vis){ ctx.clearRect(0,0,canvas.width,canvas.height); for(var k=0;k<arr.length;k++){arr[k].update();arr[k].draw();} } requestAnimationFrame(loop); })();
  }

  function canvases(){
    document.querySelectorAll('.ahana-rise-canvas:not([data-arseen])').forEach(function(cv){ cv.setAttribute('data-arseen','1'); motes(cv); });
  }

  function init(){ reveals(); canvases(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ahana-products"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__ahanaRise) return; window.__ahanaRise = true;

  function reveals() {
    document.querySelectorAll('.ahana-rise').forEach(function (s) { s.classList.add('reveal-ready'); });
    var els = [].slice.call(document.querySelectorAll('.ahana-rise [data-reveal]:not([data-arseen])'));
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('in'); e.setAttribute('data-arseen','1'); });
      return;
    }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' });
    els.forEach(function (e) { e.setAttribute('data-arseen','1'); io.observe(e); });
  }

  function motes(canvas) {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var ctx = canvas.getContext('2d');
    function resize(){ canvas.width = canvas.offsetWidth; canvas.height = canvas.offsetHeight; }
    resize();
    if ('ResizeObserver' in window) new ResizeObserver(resize).observe(canvas);
    else window.addEventListener('resize', resize, { passive:true });
    var C = ['rgba(201,150,90,','rgba(216,188,150,','rgba(160,72,48,','rgba(196,160,96,'];
    function M(){ this.reset(true); }
    M.prototype.reset = function(init){
      this.x=Math.random()*canvas.width; this.y=init?Math.random()*canvas.height:canvas.height+12;
      this.r=Math.random()*1.6+0.3; this.vy=-(Math.random()*0.35+0.08); this.vx=(Math.random()-0.5)*0.12;
      this.alpha=0; this.maxA=Math.random()*0.45+0.08; this.fade=Math.random()*0.006+0.002;
      this.phase=Math.random()*Math.PI*2; this.wobble=Math.random()*0.004+0.001;
      this.color=C[Math.floor(Math.random()*C.length)]; this.life=0; this.maxLife=Math.random()*400+200;
    };
    M.prototype.update=function(){
      this.life++; this.phase+=this.wobble; this.x+=this.vx+Math.sin(this.phase)*0.18; this.y+=this.vy;
      if(this.life<60) this.alpha=Math.min(this.maxA,this.alpha+this.fade*2.5);
      else if(this.life>this.maxLife-80) this.alpha=Math.max(0,this.alpha-this.fade*1.5);
      if(this.life>=this.maxLife||this.y<-10) this.reset(false);
    };
    M.prototype.draw=function(){ ctx.beginPath(); ctx.arc(this.x,this.y,this.r,0,Math.PI*2); ctx.fillStyle=this.color+this.alpha+')'; ctx.fill(); };
    var arr=[]; for(var i=0;i<90;i++) arr.push(new M());
    var vis=true;
    if('IntersectionObserver' in window) new IntersectionObserver(function(e){vis=e[0].isIntersecting;},{threshold:0}).observe(canvas);
    (function loop(){ if(vis){ ctx.clearRect(0,0,canvas.width,canvas.height); for(var k=0;k<arr.length;k++){arr[k].update();arr[k].draw();} } requestAnimationFrame(loop); })();
  }

  function canvases(){
    document.querySelectorAll('.ahana-rise-canvas:not([data-arseen])').forEach(function(cv){ cv.setAttribute('data-arseen','1'); motes(cv); });
  }

  function init(){ reveals(); canvases(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ahana-testimonials"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__ahanaRise) return; window.__ahanaRise = true;

  function reveals() {
    document.querySelectorAll('.ahana-rise').forEach(function (s) { s.classList.add('reveal-ready'); });
    var els = [].slice.call(document.querySelectorAll('.ahana-rise [data-reveal]:not([data-arseen])'));
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('in'); e.setAttribute('data-arseen','1'); });
      return;
    }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' });
    els.forEach(function (e) { e.setAttribute('data-arseen','1'); io.observe(e); });
  }

  function motes(canvas) {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var ctx = canvas.getContext('2d');
    function resize(){ canvas.width = canvas.offsetWidth; canvas.height = canvas.offsetHeight; }
    resize();
    if ('ResizeObserver' in window) new ResizeObserver(resize).observe(canvas);
    else window.addEventListener('resize', resize, { passive:true });
    var C = ['rgba(201,150,90,','rgba(216,188,150,','rgba(160,72,48,','rgba(196,160,96,'];
    function M(){ this.reset(true); }
    M.prototype.reset = function(init){
      this.x=Math.random()*canvas.width; this.y=init?Math.random()*canvas.height:canvas.height+12;
      this.r=Math.random()*1.6+0.3; this.vy=-(Math.random()*0.35+0.08); this.vx=(Math.random()-0.5)*0.12;
      this.alpha=0; this.maxA=Math.random()*0.45+0.08; this.fade=Math.random()*0.006+0.002;
      this.phase=Math.random()*Math.PI*2; this.wobble=Math.random()*0.004+0.001;
      this.color=C[Math.floor(Math.random()*C.length)]; this.life=0; this.maxLife=Math.random()*400+200;
    };
    M.prototype.update=function(){
      this.life++; this.phase+=this.wobble; this.x+=this.vx+Math.sin(this.phase)*0.18; this.y+=this.vy;
      if(this.life<60) this.alpha=Math.min(this.maxA,this.alpha+this.fade*2.5);
      else if(this.life>this.maxLife-80) this.alpha=Math.max(0,this.alpha-this.fade*1.5);
      if(this.life>=this.maxLife||this.y<-10) this.reset(false);
    };
    M.prototype.draw=function(){ ctx.beginPath(); ctx.arc(this.x,this.y,this.r,0,Math.PI*2); ctx.fillStyle=this.color+this.alpha+')'; ctx.fill(); };
    var arr=[]; for(var i=0;i<90;i++) arr.push(new M());
    var vis=true;
    if('IntersectionObserver' in window) new IntersectionObserver(function(e){vis=e[0].isIntersecting;},{threshold:0}).observe(canvas);
    (function loop(){ if(vis){ ctx.clearRect(0,0,canvas.width,canvas.height); for(var k=0;k<arr.length;k++){arr[k].update();arr[k].draw();} } requestAnimationFrame(loop); })();
  }

  function canvases(){
    document.querySelectorAll('.ahana-rise-canvas:not([data-arseen])').forEach(function(cv){ cv.setAttribute('data-arseen','1'); motes(cv); });
  }

  function init(){ reveals(); canvases(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
